/* © 2022 Prometheanexport const  All Rights Reservedexport const
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibitedexport const
 */
export var PROMETHEAN_SPACER_XS = '4px';
export var PROMETHEAN_SPACER_SM = '8px';
export var PROMETHEAN_SPACER_MD = '16px';
export var PROMETHEAN_SPACER_LG = '24px';
export var PROMETHEAN_SPACER_XL = '32px';
export var PROMETHEAN_SPACER_2XL = '40px';
export var PROMETHEAN_SPACER_3XL = '48px';
export var PROMETHEAN_SPACER_4XL = '56px';
export var PROMETHEAN_SPACER_5XL = '64px';
export var PROMETHEAN_SPACER_6XL = '80px';